import React, { useEffect, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton, CHeaderDivider, CFormCheck, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CFormSelect } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import AxiosInstance from 'src/components/Axios';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import useOpenAccordion from 'src/components/store/useOpenAccordion';
import CustomPagination from 'src/components/pagination/CustomPaginatiion';
import { useNavigate } from "react-router-dom";

const urlApi = '/faqs';
const urlRouter = '/faq';

const page = 1;
const postPerPage = 0;
const pageSize = 20;

export async function LoaderFaq({ params }) {
  // let res = await AxiosInstance.get(`${urlApi}?main=true&page=${page}`).then((response) => {
  let res = await AxiosInstance.get(`${urlApi}?page=${page}&language=1`).then((response) => {
    return response;
  });
  return res;
};


const Faq = ({ user_data }) => {
  if (!Permissions(user_data, 'Faq', 'VIEW_FAQ')) {
    return <PermissionsNoPage />;
  }
  const { data } = useLoaderData();
  const [rows, setRows] = useState(false);
  const [rowCountState, setRowCountState] = React.useState(0);
  const [categories, setCategories] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState('');
  const navigate = useNavigate();
  //для чекбокса
  const [selectedIds, setSelectedIds] = useState([]);

  // Викликає popup з власного компонента
  const popup = MyToastify();
  // Текст для popup
  const popupTextSuccess = "Faq видалено";

  // Відслідковувати стартове значення стану акордиону в залежності від розширення екрану
  const activeAccordionItem = useOpenAccordion();
  const activeItem = activeAccordionItem.activeItem;

  // Оновлення таблиці якщо фільтр змінився
  useEffect(() => {
    getRowsTable();
  }, [categoryFilter])

  useEffect(() => {
    AxiosInstance.get('/categories?type=faq&language=1').then(response => {
      const data = response.data['hydra:member'].map(category => {
        return {
          label: category.name,
          value: category.id
        }
      })
      setCategories(data);
    })
  }, [])

  if (!rows) {
    setRowCountState(data['hydra:totalItems'])
    setRows(data['hydra:member']);
  }

  const getRowsTable = (p = 1) => {
    // AxiosInstance.get(`${urlApi}?main=true&page=${p}`).then((response) => {
    let request = ``;
    if (categoryFilter != '') {
      request += `&category.id=${categoryFilter}`;
    };
    AxiosInstance.get(`${urlApi}?page=${p}${request}&language=1`).then((response) => {
      setRows(response.data['hydra:member']);
    });
  };

  const handlePageChange = (page) => {
    getRowsTable(page + 1);
  }

  const handleFilterReset = () => {
    setCategoryFilter('');
  }

  //обробник для чекбокса 
  const handleCheckboxToggle = (id) => {
    setSelectedIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  function Deleted(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите видалити цей пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            const response = AxiosInstance.delete(`${urlApi}/${row.id}`).then((response) => {
              // Popup про успішні зміни
              popup.toastifySuccess(popupTextSuccess);
              getRowsTable();
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  // console.log("params", params);

  const columns = [
    {
      field: 'name',
      headerName: 'Назва',
      // width: 200,
      width: 350,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isChecked = selectedIds.includes(params.row.id);

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleCheckboxToggle(params.row.id)}
              style={{
                accentColor: isChecked ? '#227965' : '#ccc',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
            />
            {params.row.name}
          </div>
        );
      }
    },
    {
      field: 'contentShort',
      headerName: 'Короткий опис',
      sortable: false,
      disableColumnMenu: true,
      width: 300,
    },
    {
      field: 'active',
      headerName: 'Активний',
      sortable: false,
      disableColumnMenu: true,
      width: 100,
      renderCell: (params) => {
        return <CFormCheck id="formCheck" label="" checked={(params.row.active != 1) ? false : true} disabled />;
      }
    },
    {
      field: 'category', headerName: 'Категорія', width: 300,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <>
          {params.row.category.map(cat => {
            return <span key={cat.id} className='category-span'>{cat.name}</span>
          })}
        </>
      }
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      // renderCell: (params) => {
      //   return <Link to={`${urlRouter}/update/${params.row.id}`}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
      // }
      renderCell: (params) => {
        return <Link to={`${urlRouter}/update/` + params.row.id}><img src="/edit.svg" alt="edit" /></Link>;
      }
    },
    {
      field: "delete",
      headerName: "Видалити",
      sortable: false,
      sortable: false,
      disableColumnMenu: true,
      // renderCell: (params) => {
      //   return <CButton color="danger" variant="outline" onClick={() => {
      //     Deleted(params.row)
      //   }
      //   }><CIcon icon={cilTrash} customClassName="nav-icon" height={20} /></CButton>;
      // }
      renderCell: (params) => {
        return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
      }
    },
  ];

  return (
    <>
      {/* Popup про успішні зміни (справа зверху) */}
      <ToastContainer />

      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CAccordion key={activeItem} activeItemKey={activeItem} flush>
              <CAccordionItem itemKey={1}>
                <CAccordionHeader><strong>Фільтр</strong></CAccordionHeader>
                <CAccordionBody>
                  <CRow className="my-3 mx-2">
                    <CCol md={9} className="me-auto">
                      <CRow>
                        <CCol md={4} className='filter-field info-col'>
                          <CFormSelect
                            aria-label="Default select"
                            onChange={(e) => { setCategoryFilter(e.target.value) }}
                            // defaultValue={categoryFilter}
                            value={categoryFilter}
                            required
                            options={[{ label: 'Всі категорії', value: '' }, ...categories]}
                          />
                        </CCol>
                        <CCol md={4} className='filter-field'>
                          <p className='pt-2'>
                            <Link
                              to={'/category/create'}
                              state={{ cat: 'faq' }}
                            >Створити категорію</Link>
                          </p>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol md={3} style={{ textAlign: "end", display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                      {/* <CButton className="me-2" type="submit" color="secondary" onClick={handleFilterSearch} disabled={disabled}>Пошук</CButton> */}
                      <CButton
                        //  style={{ height: '100%', width: '48px' }}
                        type="submit" color="secondary" onClick={handleFilterReset}>X</CButton>
                    </CCol>

                  </CRow>
                </CAccordionBody>

              </CAccordionItem>
              <div style={{ width: '100%', height: '0px', color: 'grey' }}></div>
            </CAccordion>

            <CCardHeader className='items_card_header'>
              <CButton className='me-3' type="submit" color="secondary" onClick={()=>navigate("/site-pages/update/12") }>
                <span>Редагувати сторінку <img src="/edit.svg" alt="edit" /></span>
              </CButton>
              FAQ
            </CCardHeader>

            <CCardBody>
              <div className='head_items_wrapper_solo'>
                <p className="text-medium-emphasis small">
                  <Link to={`${urlRouter}/create`} className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                    {/* Створити */}
                    Add
                  </CButton></Link>
                </p>
              </div>
              <div style={{ height: 400, width: '100%' }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={30}
                  rowsPerPageOptions={[30]}
                  pagination
                  rowCount={rowCountState}
                  paginationMode="server"
                  onPageChange={handlePageChange}

                  components={{ Pagination: CustomPagination }}
                  headerHeight={44}
                  getRowClassName={(params) =>
                    selectedIds.includes(params.row.id) ? 'active-row' : ''
                  }

                  sx={{
                    borderRadius: '12px',
                    border: '1px solid #ccc',

                    '& .MuiDataGrid-main': {
                      // borderRadius: '12px',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      borderTopLeftRadius: '12px',
                      borderTopRightRadius: '12px',
                      fontFamily: 'Inter',
                      fontWeight: '600',
                      fontSize: '12px',
                      lineheight: '150%',
                      color: '#717680',
                      //   borderBottom: '2px solid #4e73df',

                    },
                    '& .MuiDataGrid-cell': {
                      fontFamily: 'Inter',
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#434349',
                    },
                    '& .MuiDataGrid-footerContainer': {
                      // borderBottomLeftRadius: '12px',
                      // borderBottomRightRadius: '12px',
                    },
                  }}

                />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  );
};

export default Faq;